import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { CardModule } from '../../card/card.module';
import { CardListComponent } from './card-list.component';

@NgModule({
    declarations: [CardListComponent],
    imports: [CommonModule, CardModule, TranslateModule, TwcModule],
    exports: [CardListComponent],
})
export class CardListModule {}
